import React, { useState } from 'react';
import QualityControlDashboard from './QualityControlDashboard';
import InspectionsList from './InspectionsList';
import InspectionDetail from './InspectionDetail';
import InspectionCreate from './InspectionCreate';
import NonconformancesList from './NonconformancesList';
import NonconformanceDetail from './NonconformanceDetail';
import InspectionPlansList from './InspectionPlansList';
import InspectionPlanDetail from './InspectionPlanDetail';
import { useTeachingMode } from '../../contexts/TeachingModeContext';
import EnhancedTeachingAids from '../EnhancedTeachingAids';

const QualityControlView = () => {
  const [activeView, setActiveView] = useState('dashboard');
  const [selectedInspection, setSelectedInspection] = useState(null);
  const [selectedNonconformance, setSelectedNonconformance] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const { showTeachingAids } = useTeachingMode();

  const renderContent = () => {
    switch (activeView) {
      case 'dashboard':
        return (
          <QualityControlDashboard 
            onViewInspections={() => setActiveView('inspections')}
            onViewNonconformances={() => setActiveView('nonconformances')}
            onViewPlans={() => setActiveView('plans')}
          />
        );
      case 'inspections':
        return (
          <InspectionsList 
            onBack={() => setActiveView('dashboard')}
            onViewDetail={(inspection) => {
              setSelectedInspection(inspection);
              setActiveView('inspection-detail');
            }}
            onCreateNew={() => setActiveView('inspection-create')}
          />
        );
      case 'inspection-detail':
        return (
          <InspectionDetail 
            inspectionId={selectedInspection}
            onBack={() => setActiveView('inspections')}
            onViewNonconformance={(nonconformanceId) => {
              setSelectedNonconformance(nonconformanceId);
              setActiveView('nonconformance-detail');
            }}
          />
        );
      case 'inspection-create':
        return (
          <InspectionCreate 
            onBack={() => setActiveView('inspections')}
            onSave={() => setActiveView('inspections')}
          />
        );
      case 'nonconformances':
        return (
          <NonconformancesList 
            onBack={() => setActiveView('dashboard')}
            onViewDetail={(nonconformance) => {
              setSelectedNonconformance(nonconformance);
              setActiveView('nonconformance-detail');
            }}
          />
        );
      case 'nonconformance-detail':
        return (
          <NonconformanceDetail 
            nonconformanceId={selectedNonconformance}
            onBack={() => setActiveView('nonconformances')}
            onViewInspection={(inspectionId) => {
              setSelectedInspection(inspectionId);
              setActiveView('inspection-detail');
            }}
          />
        );
      case 'plans':
        return (
          <InspectionPlansList 
            onBack={() => setActiveView('dashboard')}
            onViewDetail={(plan) => {
              setSelectedPlan(plan);
              setActiveView('plan-detail');
            }}
          />
        );
      case 'plan-detail':
        return (
          <InspectionPlanDetail 
            planId={selectedPlan}
            onBack={() => setActiveView('plans')}
          />
        );
      default:
        return <QualityControlDashboard />;
    }
  };

  return (
    <div className="p-6">
      {renderContent()}
      
      {/* Teaching Aids Panel */}
      {showTeachingAids && (
        <EnhancedTeachingAids 
          module="qualityControl" 
          isVisible={true}
        />
      )}
    </div>
  );
};

export default QualityControlView;
